// AdminSidebar.js
import React, { useEffect, useState } from "react";
import SidebarItem from "../components/SidebarItem";
import "../css/SidebarItem.css";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedMenu } from "../redux/sidebarSlice";
import botIcon from "../assets/icons/botIcon.png";
import DashboardIcon from "../assets/icons/dashboardIcon.png";
import UserIcon from "../assets/icons/users.png";
import ActivityLogIcon from "../assets/icons/activity-log.png";
import FileIcon from "../assets/icons/TrainDoc.png";
import TextIcon from "../assets/icons/TrainText.png";
import LinkIcon from "../assets/icons/TrainUrl.png";
import YoutubeIcon from "../assets/icons/TrainVideo.png";
import EnterpriseIcon from "../assets/icons/enterprisesvg.png";
import QAIcon from "../assets/icons/TrainQA.png";
import ConversionIcon from "../assets/icons/convIcon.png";
import TrainingIcon from "../assets/icons/train-doc-icon.png";
import UploadIcon from "../assets/icons/filesvg.png";
import TrainIcon from "../assets/icons/TrainDocHistory.png";
import packageJson from "../../package.json";
import DomatrixLogo from "../assets/icons/DomatrixIcons/Domatrix_Logo.png";

import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";

import api from "../api";
const BASE_URL = `${process.env.REACT_APP_API_URL}/version-history`;

const AdminSidebar = ({ expanded, toggleSidebar }) => {
  const dispatch = useDispatch();
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);
  const [versions, setVersions] = useState([]);

  const handleMenuClick = (label) => {
    dispatch(setSelectedMenu(label));
  };

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchVersions = async () => {
    if (!token) {
      showErrorToast(TOAST_MESSAGES.UNAUTHORIZED);
      return;
    }
    try {
      const response = await api.get(BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVersions(response.data);
    } catch (error) {
      console.error("Failed to fetch versions", error);
      //   showErrorToast(TOAST_MESSAGES.VERSION.FETCH_ERROR);
    }
  };

  useEffect(() => {
    fetchVersions();
  }, []);

  return (
    <div
      className={`sidebar d-flex flex-column justify-content-between ${
        expanded ? "expanded" : "collapsed"
      }`}
      style={{ height: "100vh" }}
    >
      {/* Top Section */}
      <div className="d-flex flex-column justify-content-between h-100 ">
        <div>
          <div
            className={`logo-section ${
              expanded
                ? "d-flex justify-content-between align-items-center px-3"
                : "d-flex align-items-center justify-content-center gap-2 py-2"
            }`}
          >
            {expanded ? (
              <>
                <img
                  src={DomatrixLogo}
                  alt="Logo"
                  className="logo"
                  style={{ width: "160px", height: "30px", objectFit: "cover" }}
                />
                <button
                  onClick={toggleSidebar}
                  className="sidebar-toggler ms-2 "
                >
                  <i className="bi bi-chevron-double-left" />
                </button>
              </>
            ) : (
              <>
                <img
                  src={botIcon}
                  alt="Bot Icon"
                  className="bot-icon"
                  style={{ width: "28px", height: "28px", cursor: "pointer" }}
                />
                <button
                  onClick={toggleSidebar}
                  className="sidebar-toggler d-none d-md-inline"
                >
                  <i className="bi bi-chevron-double-right" />
                </button>
              </>
            )}
          </div>

          {/* Menu Items */}
          <ul className="menu">
            <SidebarItem
              icon={DashboardIcon}
              label="Dashboard"
              to="/admin/dashboard"
              expanded={expanded}
              onClick={() => handleMenuClick("Dashboard")}
              active={selectedMenu === "Dashboard"}
            />

            <SidebarItem
              icon={EnterpriseIcon}
              label="API Management"
              to="/admin/api-management"
              expanded={expanded}
              onClick={() => handleMenuClick("API Management")}
              active={selectedMenu === "API Management"}
            />

            <SidebarItem
              icon={TrainingIcon}
              label="IP Management"
              to="/admin/ip-management"
              expanded={expanded}
              onClick={() => handleMenuClick("IP Management")}
              active={selectedMenu === "IP Management"}
            />

            <SidebarItem
              icon={ActivityLogIcon}
              label="Activity Log"
              to="/admin/activity-log"
              expanded={expanded}
              onClick={() => handleMenuClick("Activity Log")}
              active={selectedMenu === "Activity Log"}
            />
          </ul>
        </div>

        <div
          className={`text-center c tooltip1 ${
            expanded ? "" : "d-none d-sm-inline-block"
          }`}
          style={{ color: "white" }}
        >
          {/* Show only latest version on sidebar */}
          {versions.length > 0 && (
            <>
              <p style={{ fontSize: "small" }}>
                {versions[0].version_number} {/* Latest version */}
              </p>

              {/* Tooltip with full version history */}
              <span className="tooltip1text">
                <table className="tooltip-table">
                  <thead>
                    <tr>
                      <th>Version</th>
                      <th>Release Date</th>
                      <th>Changes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {versions.map((v) => (
                      <tr key={v.id}>
                        <td>{v.version_number}</td>
                        <td>
                          {v.version_release_date
                            ? new Date(
                                v.version_release_date
                              ).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>{v.version_changes || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
